import { useState, useEffect, useRef } from "react"
import _uniqueId from "lodash/uniqueId"

const useCenterModal = () => {
  const whiteboxRef = useRef(null)
  const [openedCenterModals, setOpenedCenterModals] = useState([])

  const openCenterModal = ({ Component, isBackground }) => {
    setOpenedCenterModals((modals) => [
      ...modals,
      { id: _uniqueId("center_modal_"), Component, isBackground },
    ])
  }

  const closeCenterModal = (currId) => {
    setOpenedCenterModals((modals) => {
      return modals.filter(({ id }) => id !== currId)
    })
  }

  useEffect(() => {
    const handleOutSideClick = (e) => {
      if (whiteboxRef.current && !whiteboxRef.current.contains(e.target)) {
        const { id } = e.target
        closeCenterModal(id)
      }
    }
    document.addEventListener("mousedown", handleOutSideClick)
    return () => document.addEventListener("mousedown", handleOutSideClick)
  }, [])

  return { openedCenterModals, openCenterModal, closeCenterModal, whiteboxRef }
}

export default useCenterModal
